<div class="ui-g" *ngIf="timeBandPremiums">
  <div class="ui-g-12">
    <h2 class="sub-header-bar">Premium Time-Bands</h2>

    <p-table
      sortField=""
      [value]="timeBandPremiums"
      [responsive]="true"
      rowHover="true"
      resizableColumns="true"
      [(selection)]="selectedPremium"
    >
      <ng-template pTemplate="header" let-item>
        <tr (dblclick)="onRowClick($event)" [pSelectableRow]="item">
          <th></th>
          <th>Minimum Time</th>
          <th>Maximum Time</th>
          <th>Premium %</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>
            <span *ngIf="!item.customerId" class="generic-timebands">Generic</span>
            <span *ngIf="item.customerId" class="bespoke-timebands">Bespoke</span>
          </td>
          <td>
            <input
              pInputText
              [(ngModel)]="item.minTime"
              (change)="cellEdit(item)"
              [minVal]="0"
              [maxVal]="100"
              decimalDigits
              [ngModelOptions]="{ standalone: true }"
              [disabled]="isReadonly"
              appendTo="body"
            />
          </td>
          <td>
            <input
              pInputText
              [(ngModel)]="item.maxTime"
              (change)="cellEdit(item)"
              [minVal]="0"
              [maxVal]="100"
              decimalDigits
              [ngModelOptions]="{ standalone: true }"
              [disabled]="isReadonly"
              appendTo="body"
            />
          </td>
          <td>
            <input
              pInputText
              [(ngModel)]="item.premiumPercentage"
              (change)="cellEdit(item)"
              [minVal]="-50"
              [maxVal]="100"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="isReadonly"
              appendTo="body"
            />
          </td>
        </tr>
      </ng-template>
    </p-table>
    <!-- DATATABLE DEPRECATED ---
    <p-dataTabl sortField='' [value]='timeBandPremiums' [responsive]='true'
                 rowHover='true'
                 resizableColumns='true' (onRowClick)='onRowClick($event)'
                 [editable]='true' [(selection)]='selectedPremium'>
      <p-column [style]="{'width': '140px'}" [editable]='false'>
        <ng-template let-item='rowData' pTemplate='body' >
          <span *ngIf="!item.customerId" class='generic-timebands'>Generic</span>
          <span *ngIf="item.customerId" class='bespoke-timebands'>Bespoke</span>
        </ng-template>
      </p-column>

      <p-column field='minTime' header='Minimum Time' [sortable]='true' [editable]='true' >
        <ng-template let-col let-item='rowData' pTemplate='editor'>
          <input pInputText [(ngModel)]='item.minTime'
                 (change)='cellEdit(item)' [minVal]='0' [maxVal]='100' decimalDigits
                 [ngModelOptions]='{standalone: true}' appendTo='body' />
        </ng-template>
      </p-column>
      <p-column field='maxTime' header='Maximum Time' [sortable]='true' [editable]='true'>
        <ng-template let-col let-item='rowData' pTemplate='editor'>

          <input pInputText [(ngModel)]='item.maxTime'
                 (change)='cellEdit(item)' [minVal]='0' [maxVal]='100' decimalDigits
                 [ngModelOptions]='{standalone: true}' appendTo='body' />
        </ng-template>
      </p-column>
      <p-column field='premiumPercentage' header='Premium %' [sortable]='true' [editable]='true'
              >
        <ng-template let-col let-item='rowData' pTemplate='editor'>
          <input pInputText [(ngModel)]='item.premiumPercentage'
                 (change)='cellEdit(item)' [minVal]='-50' [maxVal]='100' decimalDigits
                 [ngModelOptions]='{standalone: true}' appendTo='body' />
        </ng-template>
      </p-column>

    </p-dataTable>

    -->

    <div class="footerPanel ui-grid-row">
      <button
        type="button"
        pButton
        icon="fa ui-icon-trash"
        class="ui-button red-btn btn-to-right"
        label="Delete"
        (click)="deletePremium()"
        [disabled]="!selectedPremium || isReadonly"
      ></button>
      <button
        type="button"
        pButton
        icon="fa ui-icon-add"
        (click)="addPremium()"
        label="Add"
        class="btn-to-right"
        [disabled]="isReadonly"
      ></button>
    </div>
  </div>
</div>

<p-dialog
  header="Add Premium Time-Band"
  [(visible)]="showAddPremiumDlg"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '500px' }"
>
  <div
    class="ui-grid-row ui-grid-responsive ui-fluid"
    style="margin-top: 10px; margin-bottom: 10px"
  >
    <div class="ui-grid-col-4">Minimum Time</div>
    <div class="ui-grid-col-8">
      <input pInputText [(ngModel)]="newPremium.minTime" [minVal]="0" [maxVal]="100" />
    </div>
  </div>

  <div
    class="ui-grid-row ui-grid-responsive ui-fluid"
    style="margin-top: 10px; margin-bottom: 10px"
  >
    <div class="ui-grid-col-4">Maximum Time</div>
    <div class="ui-grid-col-8">
      <input pInputText [(ngModel)]="newPremium.maxTime" [minVal]="0" [maxVal]="100" />
    </div>
  </div>

  <div
    class="ui-grid-row ui-grid-responsive ui-fluid"
    style="margin-top: 10px; margin-bottom: 10px"
  >
    <div class="ui-grid-col-4">Premium %</div>
    <div class="ui-grid-col-8">
      <input pInputText [(ngModel)]="newPremium.premiumPercentage" [minVal]="-50" [maxVal]="100" />
    </div>
  </div>

  <div class="ui-grid-row" style="margin-top: 20px">
    <button
      type="button"
      (click)="showAddPremiumDlg = false"
      pButton
      icon="fa ui-icon-close"
      label="Close"
      class="ui-button btn-to-right"
    ></button>

    <button
      type="button"
      (click)="savePremium(newPremium)"
      pButton
      label="Save"
      class="ui-button green-btn btn-to-right"
    ></button>
  </div>
</p-dialog>

<p-dialog
  header="Delete Premium Time-Band"
  [(visible)]="showDeletePremiumDlg"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '400px' }"
>
  <div
    class="ui-grid-row ui-grid-responsive ui-fluid"
    style="margin-top: 10px; margin-bottom: 10px"
  >
    <div class="ui-grid-col-12">Are you sure want to delete selected item?</div>
  </div>

  <div class="ui-grid-row" style="margin-top: 20px">
    <button
      type="button"
      (click)="showDeletePremiumDlg = false"
      pButton
      icon="fa ui-icon-close"
      label="Close"
      class="ui-button btn-to-right"
    ></button>

    <button
      type="button"
      (click)="deletePremiumConfirm(selectedPremium)"
      pButton
      label="Confirm"
      class="ui-button green-btn btn-to-right"
    ></button>
  </div>
</p-dialog>
